import { html, list, text } from 'wirejs-dom/v2';
import ProContent, { UpgradeButton } from './pro-content';
const CardPreview = require('./card-preview');
const Rules = require('../rules/index');
const API = require('../../services');
const CardService = API.Cards;
const CardResult = require('../ui/card-result').default;
const formatText = require('../../lib/format-card-text').default;
const template = require('./card-detail.tpl').default;
require('./mana-cost.css');
require('./pro-content')

export default DomClass(template, function CardDetail() {
	this.name;
	this.colors;
	this.cmc;
	this.type;
	this.text;
	this.preview = "http://gatherer.wizards.com/Handlers/Image.ashx?"
		+ "multiverseid=" + this.multiverseid
		+ "&type=card"
	;
	this.rules.assess([this]);
	this.buylink.load([this]);

	this.formattedText = formatText(this.text);

	this.relatedCards = ProContent({
		feature: 'advanced-analysis-tools',
		content: () => html`
			<div>
				<p>${text('results', null,
					r => Array.isArray(r) ? (
						r.length > 0 ? `Similar cards found.` : `No closely related cards found.`
					) : `Searching ...`
				)}</p>
				${list('results', [], r => new CardResult(r.card))}
			</div>`.onadd(self => {
				CardService.getSimilar(this).then(similar => {
					self.data.results = (similar || []).slice(0, 5)
				});
			}),
		upgradeContent: () => html`<div style='
				border: 1px solid gray;
				border-radius: 0.25rem;
				padding: 1rem;
				padding-top: 0rem;
				text-align: center;
				background-color: honeydew;
				box-shadow: 0.125rem 0.125rem 0.25rem 0rem gray;
			'>
			<div><h3 style='color: rgb(197, 75, 22);'>You're missing out!</h3>
				<b>Other players</b> are finding the cards they need <i>faster</i>!
			</div>
			<div style='text-align: center; margin: 2rem;'>${UpgradeButton({
				text: "Upgrade Now!"
			})}</div>
			<div>
				Unlock <b>card suggestions</b> and other powerful analysis tools.
			</div>
		</div>`,
	});
});
